import { Modal, Form, message } from "antd";
import VendorTransactionFields from "./VendorTransactionFields";
import { useAddVendorTransactionMutation } from "../../../services/vendor";

interface AddVendorTransactionModalProps {
  visible:     boolean;
  onCancel:    () => void;
  vendorId?:   string;
  merchantId?: string;
}

interface AddVendorTransactionFormValues {
  amount:       number;
  paymentType:  'full' | 'partial';
  paidVia:      'wallet' | 'outstanding';
  paymentMode:  'cash' | 'online';
  paidAmount?:  number;
  bill?:        string;
  paymentBill?: string;
  description?: string;
}

const AddVendorTransactionModal = ({ visible, onCancel, vendorId, merchantId }: AddVendorTransactionModalProps) => {
  const [form] = Form.useForm();
  const [addVendorTransaction, { isLoading }] = useAddVendorTransactionMutation();
  const paymentType = Form.useWatch('paymentType', form);
  const isPartial    = paymentType === 'partial';

  const handleClose = () => {
    form.resetFields();
    onCancel();
  };

  const handleFinish = async (values: AddVendorTransactionFormValues) => {
    if (!vendorId && !merchantId) return;
    const paidAmount = isPartial ? (values.paidAmount ?? 0) : values.amount;
    const dueAmount  = isPartial ? Math.max(values.amount - paidAmount, 0) : 0;
    try {
      await addVendorTransaction({
        ...(merchantId ? { merchantId } : { vendor: vendorId }),
        amount:      values.amount,
        paymentType: values.paymentType,
        paidVia:     values.paidVia,
        paymentMode: values.paymentMode,
        bill:        values.bill,
        paymentBill: values.paymentMode === 'online' ? values.paymentBill : undefined,
        description: values.description,
        paidAmount,
        dueAmount,
      }).unwrap();
      // message.success('Transaction added successfully');
      handleClose();
    } catch {
      /* error toast handled globally by badRequestHandler */
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      title="Add Transaction"
      okText="Add"
      onOk={() => form.submit()}
      confirmLoading={isLoading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <VendorTransactionFields form={form} />
      </Form>
    </Modal>
  );
};

export default AddVendorTransactionModal;
